import { render, staticRenderFns } from "./MedicationPlanInput.vue?vue&type=template&id=4b01f6b3&scoped=true"
import script from "./MedicationPlanInput.vue?vue&type=script&lang=js"
export * from "./MedicationPlanInput.vue?vue&type=script&lang=js"
import style0 from "./MedicationPlanInput.vue?vue&type=style&index=0&id=4b01f6b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01f6b3",
  null
  
)

export default component.exports